<template>
  <div class="menu-item">
    <div class="item-content" :class="menuTypeClass" @click.stop="toggleSubMenu">
      <img v-if="item.icon" :src="item.icon" alt="" />
      <span>{{ item.name }}</span>
      <i v-if="item.list" class="el-icon-arrow-down submenu-arrow" :class="{ rotated: isSubMenuOpen }"></i>
      <template v-else>
        <i v-if="!favoriteMenusIds().includes(item.id)" class="icon-fav iconfont" @click.stop="favoriteIt(item)"></i>
        <i v-else class="icon-favoured iconfont" @click.stop="cancelFavoriteIt(item)"></i>
      </template>
    </div>
    <!--line-->
    <div v-if="item.isSepaLine" class="line"></div>
    <transition name="slide-fade">
      <ul v-if="isSubMenuOpen" class="submenu">
        <SecondIndex
          v-for="child in item.list"
          :key="child.id"
          :item="child"
          :level="level + 1"
          :deep-children="true"
          :collapsed="collapsed"
          :sys-belong="sysBelong"
          @item-click="itemClick"
        />
      </ul>
    </transition>
  </div>
</template>

<script>
import SecondIndex from "@/layout/components/NewSider/SidebarItem/second-index.vue"
import { userCollectMenu, userCollectMenuDel } from "@/api/user"
import { mapActions, mapState } from "vuex"

export default {
  name: "SecondIndex",
  components: { SecondIndex },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sysBelong: {
      type: String,
      default: ""
    },
    level: {
      type: Number,
      default: 0
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    deepChildren: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSubMenuOpen: true
    }
  },
  computed: {
    // class
    menuTypeClass() {
      // 匹配激活(要判断一下系统管理和权限管理，统一项目，但是目录不是同一个，所以需要单端判断)
      if (this.$route.fullPath === this.sysBelong + "#" + this.item.url || this.$route.fullPath === "/masterData#" + this.item.url) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$parent.isSubMenuOpen = true
        return "active"
      }
      // 如果有子菜单，并且是第一级的
      if (this.item.list && !this.deepChildren) {
        return "hav-children"
      }
      // 如果有子菜单，非第一级的
      if (this.item.list && this.deepChildren) {
        return "hav-children_deep"
      }
      // 没有子菜单，非第一级的
      if (!this.item.list && this.deepChildren) {
        return "no-hav-children_deep"
      }
      return ""
    },
    ...mapState("user", ["favoriteMenus"])
  },
  methods: {
    ...mapActions("user", ["getFavorite"]),
    // 返回收藏菜单id集合
    favoriteMenusIds() {
      return this.favoriteMenus.map(item => item.id)
    },
    // 收藏菜单
    favoriteIt(item) {
      userCollectMenu({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 取消收藏
    cancelFavoriteIt(item) {
      userCollectMenuDel({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    toggleSubMenu() {
      if (this.item.list) {
        this.isSubMenuOpen = !this.isSubMenuOpen
      } else {
        this.$emit("item-click", this.item)
        // this.$bus.$emit("sidebarItemClick", this.item) // 点击叶子节点时触发事件
      }
    },
    // 点击菜单
    itemClick(item) {
      this.$emit("item-click", item)
    }
  }
}
</script>

<style scoped lang="scss">
/* 菜单组和菜单项 */
.menu-item {
  position: relative;
}

.item-content {
  background-color: #1d325b;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-content:hover {
  background-color: #2f446f;
}
.hav-children:hover {
  background-color: #2f446f !important;
}
.hav-children_deep {
  background-color: #051432 !important;
}
.hav-children_deep:hover {
  background-color: #2f446f !important;
}
.no-hav-children_deep {
  background-color: #051432 !important;
}
.no-hav-children_deep:hover {
  background-color: #2f446f !important;
}
.item-content img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.item-content i {
  margin-right: 10px;
}

.item-content span {
  flex: 1;
}

.submenu-arrow {
  transition: transform 0.3s ease;
}

.submenu-arrow.rotated {
  transform: rotate(180deg); /* 旋转箭头 */
}

.favorite-icon {
  color: #faa61a;
  margin-left: auto;
}

/* 子菜单 */
.submenu {
  background-color: #2f3136;
  min-width: 200px;
  z-index: 10;
}
.active {
  background-color: #3296fa !important;
}

/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 300px;
}

.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}
.icon-fav,
.icon-favoured {
  font-size: 12px;
  color: #faad14;
}
.line {
  width: 165px;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0px 0px 0px 0px;
  margin: 10px auto;
}
</style>
